<template>
  <el-table-column :label="label" :prop="prop" class-name="model-code" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '機種コード'
    },
    prop: {
      type: String,
      default: 'model_code'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.model-code {
      width: 9em;
    }
  }
}
</style>
